import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery} from '@apollo/react-hooks'
import {
  BalanceChartByPartnerId_partnersCharts,
  BalanceChartByPartnerId_partnersChartsVariables
} from '../../../_generated/BalanceChartByPartnerId_partnersCharts'
import { Precision } from '../../../_generated/globalTypes'

export const QUERY = gql`
query BalanceChartByPartnerId_partnersCharts($id: ID!, $precision: Precision!) {
  charts {
    byPartnerId(id: $id) {
      id: partnerId
      balance(precision: $precision) {
        begin
        valuesCount
        values
        labels
        currency
      }
    }
  }
}`

export type Q = BalanceChartByPartnerId_partnersCharts
export type V = BalanceChartByPartnerId_partnersChartsVariables
export type R = Q['charts']['byPartnerId']['balance']

export const parseData = (data: Q): R => {
  return get(data, p=> p.charts.byPartnerId.balance)

}

export function Use(partnerId: string) {
  const query = useQuery<Q, V>(
      QUERY,
      {
          variables: {
              id: partnerId,
              precision: Precision.MONTH
          }
      }
  )

  const { loading, error, data } = query

  return { loading, error, data: parseData(data) }
}
